<template>
<div id="home">
  <my-header></my-header>
  <div class="pd20">
    <div class="small-container">

      <loading v-if="loading" :text="'Please wait'|translate"></loading>
      <div v-if="profile">

        <p v-if="profile.feature_image_path" class="text-center">
          <img style="max-width:150px;" :src="profile.feature_image_path" class="corner-radius" />
        </p>

        <p class="text-center" v-if="can_mobile_share">
            <a  v-on:click="mobileShare()" > <i class="fa fa-share"></i> Chia sẻ </a>
        </p>

        <div class="row mt20 text-center" v-if="!loading">
          <div class="col-md-6 col-xs-6">
            <label class="mt10 ">Tên:</label>
            <p>{{profile.name}}</p>

            <p v-if="!profile.name">{{'No information'|translate}}</p>
          </div>
          <div class="col-md-6  col-xs-6">
            <label class="mt10 ">Điện thoại:</label>
            <p v-if="profile.phone"><a :href="'phone:'+profile.phone">{{profile.phone}}</a></p>
            <p v-if="!profile.phone">{{'No information'|translate}}</p>
          </div>
          <div class="col-md-6  col-xs-6">
            <label class="mt10">Email:</label>
            <p v-if="profile.email"><a :href="'mailto:'+profile.email">{{profile.email}}</a></p>
            <p v-if="!profile.email">{{'No information'|translate}}</p>
          </div>
          <div class="col-md-6  col-xs-6">
            <label class="mt10">Social:</label>
            <p v-if="!profile.facebook && !profile.youtube">
              Chưa có thông tin
            </p>
            <p v-else>
              <a v-if="profile.facebook" :href="profile.facebook">Facebook</a>&nbsp;
              <a v-if="profile.youtube" :href="profile.youtube">Youtube</i></a>
            </p>
          </div>

        </div>
        <!-- end col-md-6 -->
        <div class="col-md-12 text-center">
          <div v-if="profile.province_name">
            <label class="mt10">{{'Address'|translate}}:</label>
            <p class="address">{{profile.commune_name}}, {{profile.district_name}}, {{profile.province_name}}</p>
          </div>
          <div v-if="profile.group">
            <label class="mt10">{{'Member of group'|translate}}:</label>
            <p>
              <router-link :to="{ name: 'GroupProfile', params: { id: profile.group.id }}">{{profile.group.name}}</router-link>
            </p>
          </div>

          <label>Mô tả:</label>
          <div class="detail mb20">
            <p v-if="profile.description" v-html="profile.description"></p>
            <p v-if="!profile.description">{{'No information'|translate}}</p>
          </div>
          <p class="mt10 mb0"><label>Mã QR:</label></p>

          <qrcode :value="getLink()" tag="img" :options="{ width: size }"
        ref="qr" ></qrcode>
          <p><a v-on:click="downloadQR()">Lưu Mã QR</a></p>

        </div>
        <!-- end col-md-6 -->
      </div>
    </div>
    <div v-if="!loading && !profile">
      <p class="alert alert-info">Không tìm thấy người dùng này</p>
    </div>
  </div>
</div>
<!-- end pd20 -->
</div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import Loading from '@/components/elements/Loading'

export default {
  name: 'Profile',
  components: {
    MyHeader,
    Loading
  },
  data () {
    return {
      loading: true,
      profile: null,
      backup_title: '',
      can_mobile_share: navigator.share,
      value: 'https://example.com',
      size: 120
    }
  },
  watch: {
    $route (to, from) {
      console.log('from', from)
      console.log('to', to)
      this.loadInfo()
    }
  },
  methods: {
    mobileShare () {
      // alert('before');
      const shareData = {
        title: 'F2F - Nông trại đến bàn ăn',
        text: 'Hồ sơ của ' + this.profile.name,
        url: document.URL
      }

      // console.log('shareData',shareData);
      // alert('before 2');
      navigator.share(shareData)
    },
    downloadQR () {
      console.log('ere', this.$refs.qr.$el.src)
      var a = document.createElement('a') // Create <a>
      a.href = this.$refs.qr.$el.src // Image Base64 Goes here
      a.download = 'qr_code.png' // File name Here
      a.click() // Downloaded file
    },
    getLink () {
      return window.location.href
    },
    loadInfo () {
      this.loading = true
      this.profile = null
      let profileId = this.$route.params.profileId
      let wating = [Utils.request(this).get(`profile/${profileId}`)]

      Promise.all(wating).then((values) => {
        this.loading = false
        if (typeof (values[0].data.data) !== 'string') {
          this.profile = values[0].data.data

          this.backup_title = document.title
          document.title = 'Hồ sơ của ' + this.profile.name
        }
      })
    }
  },
  mounted () {
    this.loadInfo()
  },
  beforeDestroy () {
    document.title = 'NÔNG TRẠI ĐẾN BÀN ĂN'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Profile/Profile.vue